import {Dispatch} from 'redux'
import {getAccessToken} from 'setup/redux/Actions/Timetable/timetable'

import {getTheme} from '_metronic/partials'

const PLAN_SELECTION_PATH = '/PlanSelection'

type OpenPlanUpgradeOptions = {
  onStart?: () => void
  onComplete?: () => void
  onError?: (error: unknown) => void
}

/** Redirect to subscription plan selection (same flow as header Upgrade Plan). */
export function openPlanUpgradeSelection(
  dispatch: Dispatch,
  options: OpenPlanUpgradeOptions = {}
): void {
  const {onStart, onComplete, onError} = options
  onStart?.()

  dispatch(
    getAccessToken(
      (response: any) => {
        onComplete?.()
        const {accessToken, urdd_id} = response?.result || response || {}
        if (!accessToken || !urdd_id) return

        const aiCreditsUrl = window.location.hostname.includes('da1timetable.info')
          ? 'https://dev-subscription.ilmversity.ai/ai-credits'
          : import.meta.env.VITE_APP_AI_CREDITS_URL

        if (!aiCreditsUrl) return

        try {
          const sourceDomain = window.location.hostname
          const theme = getTheme()
          const returnTo = window.location.href
          const url = `${aiCreditsUrl.replace(/\/$/, '')}${PLAN_SELECTION_PATH}?accessToken=${encodeURIComponent(accessToken)}&urdd_id=${encodeURIComponent(urdd_id)}&sourceDomain=${encodeURIComponent(sourceDomain)}&theme=${encodeURIComponent(theme)}&returnTo=${encodeURIComponent(returnTo)}&intent=planSelection`
          window.location.href = url
        } catch (err) {
          onError?.(err)
        }
      },
      (error: unknown) => {
        onComplete?.()
        onError?.(error)
      }
    )
  )
}
